module.exports = __webpack_public_path__ + "static/media/banner.e4259408.png";